import React, { Component, cloneElement, useEffect, useState } from 'react';
import { animated, useSpring } from '@react-spring/web';

const PopupContext = React.createContext()

const PopupProvider = ({ children }) => {
  const [ popup, setPopup ] = useState(null);
  const [ springs, api ] = useSpring(() => ({
    from: { 
        x: '-100%'
    },
  }))

  const closePopup = () => setPopup(null);

  const setCurrentPopup = (popup) => {
    setPopup(popup);

    if (popup !== null) {
      api.start({
        from: {
          x: '-100%'
        },
        to: {
          x: '0%'
        },
      })
    }
  }

  return (
    <PopupContext.Provider
      value={{
        popup,
        setPopup: setCurrentPopup,
        closePopup,
      }}
    >
      <animated.div style={{
        //zIndex: 10,
        //...springs,
      }}>
        { popup && popup }
      </animated.div>

      { children }
    </PopupContext.Provider>
  )
}

export default PopupContext

export { PopupProvider }